module.exports = __webpack_public_path__ + "img/edit-blk.95b2e150.svg";